"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DRAFT: 'Building',
  PENDING_MASTER: 'Submitted',
  EDITING: 'Editing In Progress',
  INTERNAL_REVIEW: 'Editing In Progress',
  PENDING_REVIEW: 'Pending Review',
  APPROVED: 'Complete',
  ON_HOLD: 'On Hold'
};
exports.default = _default;